// Vendor Libs
import React from 'react';

// Containers
import FormData from './form-data';

const withForm = (WrappedComponent, formName) => {
    function WithForm(props) {
        return <FormData formName={formName}>{(formData) => <WrappedComponent {...props} {...formData} />}</FormData>;
    }

    WithForm.displayName = `WithForm(${getDisplayName(WrappedComponent)})`;

    return WithForm;
};

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withForm;
